<template>
  <div ref="tui-editor" :id="id" />
</template>

<script>
import Editor from '@toast-ui/editor'
import defaultOptions from './default-options'
import '@toast-ui/editor/dist/toastui-editor.css' // Editor's Style

export default {
  name: 'MarkdownEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: false,
      default: `markdown-editor-${new Date()}${(
        Math.random() * 1000
      ).toFixed()}`,
    },
    options: {
      type: Object,
      default() {
        return defaultOptions
      },
    },
    mode: {
      type: String,
      default: 'markdown',
    },
    height: {
      type: String,
      required: false,
      default: '300px',
    },
    language: {
      type: String,
      required: false,
      default: 'en_US', // https://github.com/nhn/tui.editor/blob/master/docs/en/i18n.md#supported-languages
    },
  },
  data() {
    return {
      editor: null,
      localValue: '',
    }
  },
  computed: {
    editorOptions() {
      const options = Object.assign({}, defaultOptions, this.options)
      options.initialEditType = this.mode
      options.height = this.height
      options.language = this.language
      return options
    },
  },
  watch: {
    value(newValue) {
      if (this.editor && this.getMarkdown() !== newValue) {
        this.editor.setMarkdown(newValue)
      }
    },
    id() {
      this.destroyEditor()
      this.initEditor()
    },
    language() {
      this.destroyEditor()
      this.initEditor()
    },
    height(newValue) {
      this.editor.height(newValue)
    },
    mode(newValue) {
      this.editor.changeMode(newValue)
    },
  },
  mounted() {
    this.initEditor()
  },
  destroyed() {
    this.destroyEditor()
  },
  methods: {
    initEditor() {
      this.editor = new Editor({
        el: this.$refs['tui-editor'],
        ...this.editorOptions,
      })

      if (this.value) this.setMarkdown(this.value)

      this.editor.on('change', () => {
        this.localValue = this.getMarkdown()
      })
      this.editor.on('blur', () => {
        this.$emit('input', this.localValue)
      })
    },
    destroyEditor() {
      if (!this.editor) return
      this.editor.destroy()
    },
    setMarkdown(value, cursorToEnd = false) {
      this.localValue = value
      this.editor.setMarkdown(value, cursorToEnd)
    },
    getMarkdown() {
      return this.editor.getMarkdown()
    },
    setHtml(value) {
      this.editor.setHtml(value)
    },
    getHtml() {
      return this.editor.getHtml()
    },
  },
}
</script>
